import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { EnvironmentProvider, getEnvironmentFromHost } from '@ori/environment';
import { TranslationsProvider } from '@ori/i18n';
import { NovageSkincareAdvisorController } from '@ori/novage-skincare-advisor';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = ({
  currentLanguage,
  tenant,
  staticApiUrl,
  globalApiUrl,
  graphqlNetUrl
}) => /*#__PURE__*/_jsx(ServiceUrlsProvider, {
  serviceUrls: {
    staticApiUrl,
    globalApiUrl,
    graphQlNetUrl: graphqlNetUrl
  },
  children: /*#__PURE__*/_jsx(EnvironmentProvider, {
    environment: getEnvironmentFromHost(window.location.host),
    tenant: tenant,
    children: /*#__PURE__*/_jsx(TranslationsProvider, {
      defaultTranslationsWithNamespaces: {},
      language: currentLanguage,
      translationsWithNamespaces: {},
      children: /*#__PURE__*/_jsx(NovageSkincareAdvisorController, {})
    })
  })
});